import { ISelector } from '@omaze/redux';

import { createSnackbarSelector } from '../Snackbar.factories';
import { ISnackbarMessage, ISnackbarState } from '../Snackbar.state';

export const selectSnackbarMessages: ISelector<ISnackbarState, ISnackbarMessage[]> =
    createSnackbarSelector((state: ISnackbarState): ISnackbarMessage[] => {
        return state.messages;
    });
